import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid-bg flex items-center justify-center">
        <div className="text-slate-400 font-mono text-sm tracking-widest">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Accepts either the production 'active' status OR the developer 'pro_tier'
// override token minted by AuthContext, OR the new local-preview 'active_business'
// override that force-unlocks the full Business-tier widget matrix.
const PAID_STATUSES = new Set(["active", "pro_tier", "active_business"]);

export function RequirePremium({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid-bg flex items-center justify-center">
        <div className="text-slate-400 font-mono text-sm tracking-widest">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!PAID_STATUSES.has(user.subscription_status)) return <Navigate to="/paywall" replace />;
  return children;
}
